import { createFileRoute, redirect } from '@tanstack/react-router';
import { OfficeSettings } from '../components/OfficeSettings';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/locations')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: OfficeSettingsComponent,
});

function OfficeSettingsComponent() {
  return <OfficeSettings />;
}
